const MAIN_IMAGE_CLASS = "vue-advanced-cropper__image";

/**
 * vue-advanced-cropper renders its <img> elements without an alt prop. Describes the main image
 * and marks the stencil preview copies decorative so screen readers announce it only once.
 */
export function setCropperImageAlt(cropperEl, fileName) {
  if (!cropperEl) return;
  const alt = fileName ? `Crop preview of ${fileName}` : "Crop preview";
  cropperEl.querySelectorAll("img").forEach((img) => {
    img.setAttribute("alt", img.classList.contains(MAIN_IMAGE_CLASS) ? alt : "");
  });
}
